// ─────────────────────────────────────────────────────────────────────────────
// MIRROR OF backend/utils/commissionRates.js — the rate Doorly actually pays.
//
// 🚨 IT EXISTS SO A CONTRACT CANNOT RETYPE A NUMBER. The Wholesale Broker
// Agreement §4 stated "one percent (1.00%)" as literal text, free to drift from
// the constant that governs the payout — the same defect the Realtor
// instrument's §3.2 had with the 5%/10% resale cap. Both renderers now fill a
// {{BROKER_COMP_PCT}} token, and test/programFeeSingleSource.test.js compares
// this file against the backend one, so the two cannot disagree about what a
// Broker is owed.
//
// ⚠️ SAME LOCKSTEP RULE AS frontend/src/constants/doorlyProgramTerms.js: the
// backend file is the source, this mirrors it, and the parity test fails if
// they drift.
// ─────────────────────────────────────────────────────────────────────────────

// 2.50% from 2026-09-23. Was 1.00%.
export const BROKER_COMP_RATE = 0.025;
export const BROKER_COMP_PCT_LABEL = `${(BROKER_COMP_RATE * 100).toFixed(2)}%`;

// ⚠️ THE REALTOR RATE, MIRRORED ON THE SAME TERMS. Realtor Services Agreement
// §4.1 stated "two percent (2.00%)" as literal text — the last retyped rate in
// either instrument. Both renderers now fill {{REALTOR_COMP_PCT}}, and the
// parity test compares this file against backend/utils/commissionRates.js, so
// the two cannot disagree about what a Broker is owed on the A-B leg.
//
// 🔑 THE BASIS DIFFERS FROM THE BROKER RATE AND THAT IS NOT INCIDENTAL. This is
// a percentage of the PURCHASE PRICE (the A-B leg); BROKER_COMP_RATE is a
// percentage of the FINANCED LOAN AMOUNT. Same-looking numbers against different
// bases are different money, which is why the parity test asserts the basis
// wording as well as the figure.
export const REALTOR_COMP_RATE = 0.02;
export const REALTOR_COMP_PCT_LABEL = `${(REALTOR_COMP_RATE * 100).toFixed(2)}%`;
